// pages/Home.js
import React, { useState, useEffect, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaRocket, FaShieldAlt, FaHeadset, FaChevronRight, FaLaptopCode, FaUsersCog, FaChartLine } from 'react-icons/fa';
import HeroScreenshot from '../../assets/images/project-consultantspage.webp';
import './Home.css';

const clients = ['Consultants Page', 'Apna Ashiyana', 'EuroWorld', 'Nexfleet', 'Daehan Links', 'OSY'];

const Home = () => {
  const navigate = useNavigate();
  const [typedText, setTypedText] = useState('');
  const phrases = useMemo(() => ['Websites', 'SaaS Platforms', 'Custom CRMs', 'Web Applications'], []);
  const [currentPhrase, setCurrentPhrase] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const handleTyping = () => {
      const current = phrases[currentPhrase];
      
      if (!isDeleting && typedText === current) {
        setTimeout(() => setIsDeleting(true), 2000);
        return;
      }
      
      if (isDeleting && typedText === '') {
        setIsDeleting(false);
        setCurrentPhrase((prev) => (prev + 1) % phrases.length);
        return;
      }

      const timeout = setTimeout(() => {
        setTypedText(isDeleting 
          ? current.substring(0, typedText.length - 1)
          : current.substring(0, typedText.length + 1)
        );
      }, isDeleting ? 50 : 100);

      return () => clearTimeout(timeout);
    };

    const timer = setTimeout(handleTyping, 100);
    return () => clearTimeout(timer);
  }, [typedText, isDeleting, currentPhrase, phrases]);



  return (
    <section id="home" className="hero-section">
      <div className="animated-bg">
        <div className="bg-grid"></div>
      </div>
      
      <div className="container">
        <div className="hero-grid">
          {/* Left Content - YOUR ORIGINAL CONTENT */}
          <div className="hero-left fade-in">
            <div className="hero-badge">
              <span className="badge-dot"></span>
              <span>Available for new projects</span>
            </div>
            
            <h1 className="hero-title">
              Transform Your Digital Presence with 
              <span className="gradient-text"> Expert </span>
              <span className="typing-text">{typedText}</span>
              <span className="cursor">|</span>
            </h1>
            
            <p className="hero-description">
              We deliver cutting-edge digital solutions that drive real business growth. 
              From stunning websites to powerful applications, we turn your vision into 
              measurable results.
            </p>
            
            <div className="hero-stats">
              <div className="stat">
                <div className="stat-number">98%</div>
                <div className="stat-label">Client Satisfaction</div>
              </div>
              <div className="stat">
                <div className="stat-number">250+</div>
                <div className="stat-label">Projects Delivered</div>
              </div>
              <div className="stat">
                <div className="stat-number">24/7</div>
                <div className="stat-label">Support Available</div>
              </div>
            </div>
            
            <div className="hero-actions">
              <button
                className="btn btn-primary"
                onClick={() => navigate('/contact')}
              >
                <span>Get Free Quote</span>
                <FaChevronRight />
              </button>
              <Link to="/portfolio" className="btn btn-outline">
                View Our Work
              </Link>
            </div>

            <div className="hero-trust">
              <div className="trust-label">Products we built are live for:</div>
              <div className="trust-logos">
                {clients.map((client) => (
                  <span key={client} className="logo">{client}</span>
                ))}
              </div>
            </div>
          </div>

          {/* Right Content - YOUR ORIGINAL VISUAL */}
          <div className="hero-right fade-in">
            <div className="hero-visual">
              <div className="floating-card card-1">
                <div className="card-icon"><FaUsersCog /></div>
                <div className="card-content">
                  <h4>SaaS & CRM</h4>
                  <p>Multi-tenant platforms</p>
                </div>
                <div className="card-badge">Popular</div>
              </div>

              <div className="floating-card card-2">
                <div className="card-icon"><FaLaptopCode /></div>
                <div className="card-content">
                  <h4>Web Apps</h4>
                  <p>React & Next.js</p>
                </div>
              </div>

              <div className="floating-card card-3">
                <div className="card-icon"><FaChartLine /></div>
                <div className="card-content">
                  <h4>Dashboards</h4>
                  <p>Real-time analytics</p>
                </div>
              </div>
              
              <div className="main-visual">
                <div className="visual-container">
                  <div className="screen-mockup">
                    <div className="screen-header">
                      <div className="dots">
                        <div className="dot red"></div>
                        <div className="dot yellow"></div>
                        <div className="dot green"></div>
                      </div>
                    </div>
                    <div className="screen-content screen-shot">
                      <img src={HeroScreenshot} alt="Consultants Page SaaS CRM built by GForce Solutions" fetchPriority="high" />
                    </div>
                  </div>
                  <div className="glow-effect"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Features Bar - YOUR ORIGINAL CONTENT */}
        <div className="features-bar">
          <div className="feature">
            <div className="feature-icon">
              <FaRocket />
            </div>
            <div className="feature-content">
              <h4>Fast Delivery</h4>
              <p>Launch in 2-4 weeks</p>
            </div>
          </div>
          
          <div className="divider"></div>
          
          <div className="feature">
            <div className="feature-icon">
              <FaShieldAlt />
            </div>
            <div className="feature-content">
              <h4>Quality Guaranteed</h4>
              <p>6-month maintenance</p>
            </div>
          </div>
          
          <div className="divider"></div>
          
          <div className="feature">
            <div className="feature-icon">
              <FaHeadset />
            </div>
            <div className="feature-content">
              <h4>24/7 Support</h4>
              <p>Always available</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;